import { createFilterOptions } from '@material-ui/lab/useAutocomplete';
import _ from 'lodash';
import React, { useCallback, useEffect, useState, useMemo } from 'react';
import QCXAutocompleteSelect from '../autocomplete-select/QCXAutocompleteSelect';
import i18n from '../../i18n';

export default function QCXSelectTipoAutocomplete({ label, name, initialValues, ...restProps }) {

    const [defaultValue, setDefaultValue] = useState('');

    const list = useMemo(
        () => [
            {
                label: i18n.t('com.muralis.qcx.documento.tipo.original'),
                value: 'ORIGINAL',
            },
            {
                label: i18n.t('com.muralis.qcx.documento.tipo.copia'),
                value: 'COPIA',
            },
        ],
        []
    );

    useEffect(() => {
        
        const defaultInitialValue = _.get(initialValues, name);

      
        const option = list.find((item) => item?.value === defaultInitialValue);

        if (option) {
            
            setDefaultValue(option);
        } else {
            
            setDefaultValue('');
        }
    }, [list, initialValues, name]); 

    const filterOptions = useMemo(
        () =>
            createFilterOptions({
                stringify: (option) => option.label + option.value,
            }),
        []
    );

    const getOptionLabel = useCallback((item) => item?.label || '', []);

    const getOptionValue = useCallback((item) => item?.value || '', []);

    return (
        <QCXAutocompleteSelect
            label={label}
            id={name}
            name={name}
            options={list} 
            filterOptions={filterOptions}
            defaultValue={defaultValue} 
            getOptionLabel={getOptionLabel}
            getOptionValue={getOptionValue}
            {...restProps} 
        />
    );
}